import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm.competencias.length > 0
        ? _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                [
                  _c(
                    VRow,
                    {
                      staticClass: "mb-4",
                      attrs: { id: "grafico-barras", "no-gutters": "" },
                    },
                    [
                      _c(
                        VCol,
                        [
                          _c("bar-chart", {
                            staticClass: "chart",
                            attrs: {
                              categorias: [],
                              dados: _vm.dadosBarChart,
                              fonte: `Fonte: Sistema Desenvolva, ${_vm.anoMapeamento}`,
                              legenda: _vm.legendaBarChart,
                              titulo: _vm.tituloBarChart,
                              tooltip: _vm.tooltipBarChart,
                              "descricao-eixo-y": "Quantidade",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.competencias.length > 0
                    ? _c(
                        VRow,
                        { attrs: { id: "grafico-pizza", "no-gutters": "" } },
                        [
                          _c(
                            VCol,
                            [
                              _c("pie-chart", {
                                staticClass: "chart",
                                attrs: {
                                  dados: _vm.dadosPieChart,
                                  fonte: `Fonte: Sistema Desenvolva, ${_vm.anoMapeamento}`,
                                  titulo: _vm.tituloPieChart,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.totalCompetenciasInseridas > 0
                    ? _c(
                        VRow,
                        { staticClass: "justify-center" },
                        [
                          _c(
                            VRadioGroup,
                            {
                              attrs: { row: "" },
                              model: {
                                value: _vm.visualizacaoCompetencias,
                                callback: function ($$v) {
                                  _vm.visualizacaoCompetencias = $$v
                                },
                                expression: "visualizacaoCompetencias",
                              },
                            },
                            [
                              _c(VRadio, {
                                attrs: { label: "Todas", value: "TODAS" },
                              }),
                              _c(VRadio, {
                                attrs: { label: "Gerais", value: "GERAIS" },
                              }),
                              _c(VRadio, {
                                attrs: {
                                  label: "Inseridas",
                                  value: "INSERIDAS",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        [_c("app-title", { attrs: { texto: "RESULTADOS" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        [
                          _c("app-sort", {
                            model: {
                              value: _vm.opcoes,
                              callback: function ($$v) {
                                _vm.opcoes = $$v
                              },
                              expression: "opcoes",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(VSpacer),
                      _c(
                        VCol,
                        [
                          _c("app-search", {
                            model: {
                              value: _vm.opcoes,
                              callback: function ($$v) {
                                _vm.opcoes = $$v
                              },
                              expression: "opcoes",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        [
                          _c(VDataTable, {
                            staticClass: "elevation-0",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.competencias,
                              search: _vm.opcoes.pesquisa,
                              "sort-by": _vm.opcoes.ordenarPor,
                              "sort-desc": _vm.opcoes.decrescente,
                              "align-content-space-between": "",
                              "disable-pagination": "",
                              "hide-default-footer": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: `item.numero`,
                                  fn: function ({ index }) {
                                    return [
                                      _vm._v(" " + _vm._s(index + 1) + " "),
                                    ]
                                  },
                                },
                                {
                                  key: `item.competenciaTecnica.nome`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          class:
                                            item.competenciaTecnica.unidades
                                              .length > 0
                                              ? "grey-text"
                                              : "secondary--text",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.competenciaTecnica.nome
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: `item.competenciaTecnica.tipo`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          class:
                                            item.competenciaTecnica.unidades
                                              .length > 0
                                              ? "grey-text"
                                              : "secondary--text",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.competenciaTecnica.tipo
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: `body.append`,
                                  fn: function () {
                                    return [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            attrs: {
                                              align: "center",
                                              colspan: "3",
                                            },
                                          },
                                          [
                                            _c(
                                              "strong",
                                              {
                                                staticClass:
                                                  "subtitle-2 grey--text text--darken-2",
                                              },
                                              [_vm._v("TOTAL")]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "td",
                                          { attrs: { align: "center" } },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.totalCompetencias)
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                      _c(VDivider),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "justify-end mb-1" },
                    [
                      _c(
                        VTooltip,
                        {
                          attrs: { "max-width": "400", top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      VBtn,
                                      _vm._g(
                                        {
                                          attrs: { color: "success" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.getRelatorio()
                                            },
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _c(VIcon, [_vm._v("get_app")]),
                                        _vm._v(" BAIXAR PDF "),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3755186528
                          ),
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "Clique para baixar o relatório dos dados em formato PDF."
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c("app-alert", {
                    attrs: {
                      icon: "info",
                      message:
                        "Não há competências técnicas consolidadas na(s) unidade(s).",
                      type: "info",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }